import { useState } from 'react';
import { IconUser } from '@tabler/icons-react';
import Busqueda from '../components/Busqueda';

const dummyChats = [
  {
    id: 1,
    name: 'María García',
    lastMessage: '¿Tienen disponibilidad de capuchino grande?',
    time: '14:30',
    unread: 2,
    messages: [
      { id: 1, from: 'client', text: 'Hola, buenas tardes', time: '14:25' },
      { id: 2, from: 'client', text: '¿Tienen disponibilidad de capuchino grande?', time: '14:30' },
    ],
  },
  {
    id: 2,
    name: 'Carlos López',
    lastMessage: 'Mi pedido ya está listo?',
    time: '13:45',
    unread: 0,
    messages: [
      { id: 1, from: 'client', text: 'Buenos días', time: '13:40' },
      { id: 2, from: 'client', text: 'Mi pedido ya está listo?', time: '13:45' },
      { id: 3, from: 'staff', text: 'Hola Carlos, está en preparación', time: '13:46' },
    ],
  },
  {
    id: 3,
    name: 'Ana Martínez',
    lastMessage: 'Gracias por la atención',
    time: '12:20',
    unread: 0,
    messages: [
      { id: 1, from: 'client', text: '¿Cuánto tarda el smoothie?', time: '12:15' },
      { id: 2, from: 'staff', text: 'Aproximadamente 5 minutos', time: '12:16' },
      { id: 3, from: 'client', text: 'Gracias por la atención', time: '12:20' },
    ],
  },
  {
    id: 4,
    name: 'Pedro Sánchez',
    lastMessage: '¿Hacen envíos a la zona norte?',
    time: '11:10',
    unread: 1,
    messages: [
      { id: 1, from: 'client', text: '¿Hacen envíos a la zona norte?', time: '11:10' },
    ],
  },
  {
    id: 5,
    name: 'Laura Fernández',
    lastMessage: 'Quisiera hacer un pedido grande para evento',
    time: '10:05',
    unread: 3,
    messages: [
      { id: 1, from: 'client', text: 'Buenos días', time: '10:00' },
      { id: 2, from: 'client', text: 'Quisiera hacer un pedido grande para evento', time: '10:05' },
    ],
  },
];

function ChatItem({ chat, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 text-left border-none cursor-pointer"
      style={{
        padding: '14px 16px',
        backgroundColor: active ? 'rgba(3, 78, 162, 0.2)' : 'transparent',
        borderRadius: '12px',
        fontFamily: '"Public Sans", sans-serif',
      }}
    >
      <div
        className="flex items-center justify-center shrink-0"
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '9999px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        }}
      >
        <IconUser size={20} color="#fff" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <span className="text-[#8D8D8D] font-medium truncate" style={{ fontSize: '14px' }}>
            {chat.name}
          </span>
          <span className="shrink-0" style={{ fontSize: '12px', fontWeight: 500, color: '#8D8D8D', fontFamily: '"Public Sans", sans-serif' }}>
            {chat.time}
          </span>
        </div>
        <div className="flex items-center justify-between mt-1">
          <span className="truncate" style={{ fontSize: '13px', fontWeight: 500, color: chat.unread > 0 ? '#fff' : '#8D8D8D', fontFamily: '"Public Sans", sans-serif' }}>
            {chat.lastMessage}
          </span>
          {chat.unread > 0 && (
            <span
              className="flex items-center justify-center shrink-0 ml-2"
              style={{
                minWidth: '20px',
                height: '20px',
                borderRadius: '9999px',
                backgroundColor: '#fff',
                padding: '0 6px',
                fontSize: '11px',
                color: '#000',
              }}
            >
              {chat.unread}
            </span>
          )}
        </div>
      </div>
    </button>
  );
}

function ChatPanel({ chat }) {
  if (!chat) {
    return (
      <div className="flex-1 flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)' }}>
        <p style={{ fontSize: '14px', fontWeight: 500, color: '#8D8D8D', fontFamily: '"Public Sans", sans-serif' }}>
          Selecciona una conversación
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)' }}>
      {/* Chat header */}
      <div
        className="flex items-center gap-3 px-6"
        style={{ height: '64px', borderBottom: '1px solid #343434' }}
      >
        <div
          className="flex items-center justify-center"
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '9999px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          }}
        >
          <IconUser size={18} color="#fff" />
        </div>
        <span className="text-[#8D8D8D] font-medium" style={{ fontSize: '14px', fontFamily: '"Public Sans", sans-serif' }}>
          {chat.name}
        </span>
      </div>

      {/* Messages */}
      <div className="flex-1 flex flex-col gap-3 p-6 overflow-y-auto">
        {chat.messages.map((msg) => (
          <div
            key={msg.id}
            className="flex"
            style={{ justifyContent: msg.from === 'staff' ? 'flex-end' : 'flex-start' }}
          >
            <div
              style={{
                maxWidth: '70%',
                padding: '10px 14px',
                borderRadius: '16px',
                backgroundColor: msg.from === 'staff' ? '#034EA2' : 'rgba(255, 255, 255, 0.1)',
                fontFamily: '"Public Sans", sans-serif',
              }}
            >
              <p className="m-0" style={{ fontSize: '14px', color: '#fff' }}>
                {msg.text}
              </p>
              <p className="m-0 mt-1" style={{ fontSize: '11px', color: 'rgba(255, 255, 255, 0.5)' }}>
                {msg.time}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Input */}
      <div className="flex items-center gap-3 px-6 py-4" style={{ borderTop: '1px solid #343434' }}>
        <input
          type="text"
          placeholder="Escribe un mensaje..."
          className="flex-1 text-white outline-none"
          style={{
            height: '40px',
            padding: '0 16px',
            borderRadius: '9999px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            fontSize: '14px',
            fontWeight: 500,
            fontFamily: '"Public Sans", sans-serif',
          }}
        />
        <button
          className="text-white font-medium flex items-center justify-center"
          style={{
            height: '40px',
            padding: '0 24px',
            borderRadius: '9999px',
            backgroundColor: '#034EA2',
            border: 'none',
            cursor: 'pointer',
            fontSize: '14px',
            fontFamily: '"Public Sans", sans-serif',
          }}
        >
          Enviar
        </button>
      </div>
    </div>
  );
}

export default function ChatClientes() {
  const [activeChat, setActiveChat] = useState(null);

  return (
    <div className="flex flex-col h-screen bg-black overflow-hidden">
      <header
        className="flex items-center justify-between px-6"
        style={{
          height: '112px',
          borderBottom: '1px solid #343434',
        }}
      >
        <div>
          <h1
            className="text-white font-semibold uppercase m-0"
            style={{ fontSize: '24px', fontFamily: '"Public Sans", sans-serif' }}
          >
            Chat de clientes
          </h1>
          <p
            className="m-0 mt-1"
            style={{ fontSize: '14px', fontWeight: 500, color: '#8D8D8D', fontFamily: '"Public Sans", sans-serif' }}
          >
            conversaciones y atención al cliente
          </p>
        </div>
        <Busqueda />
      </header>
      <div className="flex-1 flex min-h-0">
        {/* Client list */}
        <div
          className="flex flex-col gap-1 p-4 overflow-y-auto"
          style={{
            width: '380px',
            borderRight: '1px solid #343434',
          }}
        >
          {dummyChats.map((chat) => (
            <ChatItem
              key={chat.id}
              chat={chat}
              active={activeChat?.id === chat.id}
              onClick={() => setActiveChat(chat)}
            />
          ))}
        </div>

        {/* Chat panel */}
        <ChatPanel chat={activeChat} />
      </div>
    </div>
  );
}
